﻿'use strict';

angular.module('ntmApp').factory('WeeklyDaysFilter', function () {

    function WeeklyDaysFilter() {

        this.selectedDays = [];

        this.daysOfWeek = [
          { label: 'Su', dayOfWeek: 0 },
          { label: 'M',  dayOfWeek: 1 },
          { label: 'Tu', dayOfWeek: 2 },
          { label: 'W',  dayOfWeek: 3 },
          { label: 'Th', dayOfWeek: 4 },
          { label: 'F',  dayOfWeek: 5 },
          { label: 'S', dayOfWeek: 6 }
        ];

        this.isDefined = function () {
            return this.selectedDays.length > 0;
        };

        this.isPartlyDefined = function () {
            return this.selectedDays.length > 0;
        };

        this.clear = function () {
            this.selectedDays = [];
        };

        this.getLabel = function () {
            var daysLabels = this.selectedDays.sort(function (day1, day2) {
                return day1.dayOfWeek - day2.dayOfWeek;
            }).map(function (day) {
                return day.label;
            });

            return daysLabels.join(', ');
        };
    }

    return (WeeklyDaysFilter);
});